import http from './http';

export default {
  update(data) {
    return http().put(`/v1/contact_contact_types/${data.id}`, data);
  },
}
